import { PUBLIC_IDM_API_URL_ENV } from 'tools/environments';
import { PostMarketingRequest, PostMarketingResponse } from './types';

export const postMarketing = async (payload: PostMarketingRequest, lang = 'en', token: string | null | undefined): Promise<PostMarketingResponse> => {
    const headers = {
        'Content-Type': 'application/json',
        ...(token && { "X-XSRF-TOKEN": token }),
    };
    const search = window.location.search;
    const queryParams = [`culture=${lang}`];
    if (search) queryParams.push(search.slice(1));

    const res = await fetch(`${PUBLIC_IDM_API_URL_ENV}/marketing?${queryParams.join('&')}`, {
        method: 'POST',
        credentials: 'include',
        headers: headers,
        body: JSON.stringify(payload),
    });

    if (!res.ok) {
        throw new Error(`Failed to post marketing preferences: ${res.status} ${res.statusText}`);
    }

    return (await res.json()) as PostMarketingResponse;
};
